
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
function footer() {
    return (
      <>
        
        

<footer className="footer bg-black text-center">
  <div  className="container">
    <p  className="text-muted">&copy;高本電業株式会社</p>
  </div>
</footer>
      </>
    );
  }

export default footer;